import React, { useEffect, useState } from "react";
import HttpTool from "../../../../tool/HttpTool";
import { message, Spin, Button } from "antd";
import styles from "./BusinessChart.less";
import BaseChart from "../baseChart/BaseChart.tsx";
import { ReloadOutlined } from "@ant-design/icons";
import APILXD from "../../../../http/APILXD";

type Props = {
  pageParams: any;
  loading?: boolean;
}

export default function(props:Props) {
  const [loading, setLoading] = useState(props.loading || false);

  const [chartConfig, setChartConfig] = useState({
    tooltip: {
      trigger: 'item',
      formatter: '{b} : {c}台 ({d}%)'
    },
    legend: {show: true}
  });

  useEffect(() => {
    getData();
  }, [props.pageParams]);

  const getData= ()=>{
    setLoading(true)
    HttpTool.post(APILXD.businessIPStatistics, (code: any, msg: any, json: any) => {

      let seriesData = [];

      if(json.existIpCount){
        seriesData.push({
          name: '有IP',
          value: json.existIpCount,
          itemStyle: {
            color: 'dodgerblue',
          }
        })
      }
      if(json.noIpCount){
        seriesData.push({
          name: '无IP',
          value: json.noIpCount,
          itemStyle: {
            color: 'darkorange',
          }
        })
      }

      setChartConfig((oldConfig)=>{
        let newConfig = {...oldConfig}
        newConfig.series = [
          {
            type: 'pie',
            radius: ['0%', '70%'],
            itemStyle: {
              borderRadius: ['5%', '5%'],
            },
            label:{
              formatter: `{b}\n{c}台（{d}%）`,
            },
            data: seriesData
          },
        ];
        return newConfig;
      })

      setLoading(false)
    }, (code: any, msg: any) => {
      message.error(msg);
      setLoading(false)
    }, {
      ...props.pageParams,
    });
  }

  return <Spin wrapperClassName={styles.spinBoxStyle} spinning={loading}>
    <div className={styles.itemBox}>
      <div className={styles.title}>
        <Button
          type={'link'}
          icon={<ReloadOutlined />}
          onClick={() => {
            getData();
          }}
        />
        IP统计
      </div>
      <BaseChart
        chartType={"pie"}
        chartConfig={chartConfig}
      />
    </div>
  </Spin>;
}
